import React, { useState } from 'react';

import { Row, Col, Button } from 'react-bootstrap';
import Fade from 'react-bootstrap/Fade';
import Activities_Left from '../Activities/Activities_Left'

import Breadcrumb from '../../Breadcrumb/Main'
import Header from '../../headerone/Main'


function Social() {

    const [OrphanOpen, setOrphan] = useState(true);
    const [BloodOpen, setBloodOpen] = useState(false);
    const [NssOpen, setNssOpen] = useState(false);

    const handleClick = (event) => {
        setOrphan(false);
        setBloodOpen(false);
        setNssOpen(false);
        event(true);
    }



    const OrphanMotherIMG = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/social/1.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/social/2.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/social/3.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/social/4.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/social/5.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/social/6.jpg" }
    ]

    const OrphanAbhayaIMG = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/NSS/1.jpg" }

    ]



    const BloodIMG = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/social/7.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/social/8.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/social/9.jpg" }

    ]


    const NssIMG1 = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/NSS/2.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/NSS/3.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/NSS/4.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/NSS/5.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/NSS/6.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/NSS/7.png" }
    ]

    const NssIMG2 = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/NSS/8.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/NSS/9.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/NSS/10.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/NSS/11.png" }

    ]


    return (

        <>
            <Header />
            <Breadcrumb title='Home' subtitle="Social" />



            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">
                        <Row>
                            <div className="c-heading">
                                <h3>SOCIAL</h3> <br />
                            </div>

                            <Col md={3} className='c-left custom-padding-color mb-4'>
                                <Activities_Left activeIndex={4} />
                            </Col>

                            <Col md={9} className='c-right'>
               
                                <Row className='mb-5 text-center'>

                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button'
                                            onClick={() => handleClick(setOrphan)}
                                            aria-controls="example-fade-text"
                                            aria-expanded={OrphanOpen}>
                                            Orphan Visit
                                        </Button>
                                    </Col>

                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button '
                                            onClick={() => handleClick(setBloodOpen)}
                                            aria-controls="c-guidelines"
                                            aria-expanded={BloodOpen}>
                                            Blood Donation
                                        </Button>
                                    </Col>


                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button '
                                            onClick={() => handleClick(setNssOpen)}
                                            aria-controls="c-guidelines"
                                            aria-expanded={NssOpen}>
                                            NSS Activities
                                        </Button>
                                    </Col>

                                </Row>


                                {/*dates */}
                                <div>
                                    {OrphanOpen && <Fade in={OrphanOpen}>
                                        <div>

                                            <h3 className='c-headline mt-5 mb-3'>Mother Teresa Foundation - November 11th 2015 </h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {OrphanMotherIMG.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>


                                            <h3 className='c-headline mt-5 mb-3'>Abhaya Kshetram(Orphanage) - Feb 25th 2017</h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {OrphanAbhayaIMG.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>

                                        </div>
                                    </Fade>
                                    }
                                </div>


                                {/*Guidelines*/}

                                <div>
                                    {BloodOpen && <Fade in={BloodOpen}>
                                        <div>

                                            <h3 className='c-headline mt-5 mb-3'>Blood Donation - August 28th 2016</h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {BloodIMG.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>

                                        </div>
                                    </Fade>
                                    }
                                </div>


                                <div>
                                    {NssOpen && <Fade in={NssOpen}>
                                        <div>

                                            <h3 className='c-headline mt-5 mb-3'>NSS Activities at Kendriya Vidyalaya - October 4th 2016 </h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {NssIMG1.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>



                                            <h3 className='c-headline mt-5 mb-3'>NSS Activities at Science Center - 11th and 12th February, 2017  </h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {NssIMG2.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>

                                        </div>
                                    </Fade>
                                    }
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Social;
